module.exports = __webpack_public_path__ + "img/icons-Pencil-Line.8770c386.svg";